import "./SignaturePadComponent.scss";
import SignatureCanvas from 'react-signature-canvas';
import React, {useCallback, useRef, useState} from "react";
import ButtonComponent from "../button/ButtonComponent";

interface SignaturePadComponentProps {
    showPreview?: boolean;
    onSign?: (signImage: string | null) => void;
    note?: string;
}

const SignaturePadComponent = (props: SignaturePadComponentProps) => {

    const {onSign,note} = props;
    const sigCanvasRef = useRef<any>();
    // const [isDrawing, setIsDrawing] = useState(false);
    const [signImage, setSignImage] = useState<any>(null);


    const handleDrawEnd = useCallback(() => {
        const signImage = sigCanvasRef.current.getTrimmedCanvas().toDataURL('image/png');
        setSignImage(signImage);
        // setIsDrawing(false);
    }, []);


    const handleClearSign = useCallback(() => {
        if (sigCanvasRef.current) {
            sigCanvasRef.current.clear();
            setSignImage(null);
        }
    }, []);

    const handleOnSign = useCallback(() => {
        if (onSign && signImage) {
            const tempSignImage = signImage;
            handleClearSign();
            onSign(tempSignImage);
        }
    }, [onSign,signImage,handleClearSign]);

    return (
        <div className={'signature-pad-component'}>
            <div className={'signature-pad-container'}>
                <div className={'signature-pad'} style={{cursor: 'url(sign.svg), auto'}}>
                    <SignatureCanvas
                        ref={sigCanvasRef}
                        clearOnResize={false}
                        canvasProps={{className: 'signature-pad-canvas'}}
                        // onBegin={() => setIsDrawing(true)}
                        onEnd={() => handleDrawEnd()}
                    />
                   <div className={'signature-pad-draw-line'}></div>
                </div>
                {note && <div className={'signature-pad-note'}>
                    {note}
                </div>}
                {/*<div className="signature-pad-options">*/}
                {/*    <LinkComponent disabled={!signImage} onClick={handleClearSign}*/}
                {/*                   className={'signature-pad-clear pdd-top-15'}>*/}
                {/*        Clear Signature*/}
                {/*    </LinkComponent>*/}
                {/*</div>*/}
            </div>
            <div className={'signature-pad-actions-wrapper'}>
                <ButtonComponent
                    disabled={!signImage}
                    onClick={handleClearSign}
                    variant={'outlined'}
                    color={'default'}
                    >
                    Clear
                </ButtonComponent>
                <ButtonComponent
                    disabled={!signImage}
                    onClick={()=>handleOnSign()}
                    variant={'contained'}
                    >
                    Save
                </ButtonComponent>
            </div>
            {/*{(signImage && showPreview) && <div className={'signature-pad-image-preview'}>*/}
            {/*    <img src={signImage} alt={'sign-preview'} style={{height: '60px', width: '120px'}}/>*/}
            {/*</div>}*/}
        </div>
    );

};

export default SignaturePadComponent;


// ****************************** USAGE ****************************** //

//
// <SignaturePadComponent showPreview={true} onSign={(signImage) => {
//     console.log(signImage);
// }}/>

// ****************************** USAGE ****************************** //
